/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */
<template>
  <div>
    <b-form>
      <b-tabs>
        <b-tab title="Dados Pessoais">
          <div class="row">
            <div class="col-md-4">
              <b-form-group id="input-group-1" label="Nome do Produtor" label-for="input-1">
                <b-form-input id="input-1" v-model="produtor.nome" type="text" placeholder="Informe o nome do produtor"
                  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-12"></div>
            <div class="col-md-4">
              <b-form-group id="input-group-propriedade" label="Nome da Propriedade" label-for="input-propriedade">
                <b-form-input id="input-propriedade" v-model="produtor.propriedade" type="text" placeholder="Informe o nome da propriedade"
                  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-12"></div>
            <div class="col-md-4">
              <b-form-group id="input-group-2" label="CPF/CNPJ" label-for="input-2">
                <b-form-input id="input-2" v-model="produtor.cpf_cnpj" v-mask="['###.###.###-##', '##.###.###/####-##']"
                  type="text" placeholder="Informe o CPF ou CNPJ" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-12"></div>
            <div class="col-md-4">
              <b-form-group id="input-group-2" label="Inscrição Estadual" label-for="input-2">
                <b-form-input id="input-2" v-model="produtor.inscricao_estadual" type="text"
                  placeholder="Informe a Inscrição Estadual"></b-form-input>
              </b-form-group>
            </div>
          </div>
        </b-tab>
        <b-tab title="Dados de Endereço">
          <div class="row">
            <div class="col-md-2">
              <b-form-group id="input-group-7" label="CEP" label-for="input-7">
                <b-row no-gutters>
                  <b-col cols="9" class="pr-2">
                    <b-form-input id="input-7" v-model="produtor.cep" v-mask="['#####-###']" type="text"
                      placeholder="Informe o CEP" required></b-form-input>
                  </b-col>
                  <b-col cols="3">
                    <b-button type="button" variant="primary" @click.prevent="procurarCEP">Buscar</b-button>
                  </b-col>
                </b-row>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group id="input-group-4" label="Endereço" label-for="input-4">
                <b-form-input id="input-4" v-model="produtor.endereco" type="text" placeholder="Informe o endereço"
                  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group id="input-group-6" label="Número" label-for="input-6">
                <b-form-input id="input-6" v-model="produtor.numero" type="text" placeholder="Informe o número"
                  required></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <b-form-group id="input-group-6" label="Complemento" label-for="input-12">
                <b-form-input id="input-12" v-model="produtor.complemento" type="text"
                  placeholder="Informe o complemento" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group id="input-group-5" label="Bairro" label-for="input-5">
                <b-form-input id="input-5" v-model="produtor.localidade" type="text" placeholder="Informe o bairro"
                  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group id="input-group-3" label="Telefone" label-for="input-3">
                <b-form-input id="input-3" v-model="produtor.telefone" v-mask="['(##) ####-####', '(##) #####-####']"
                  type="text" placeholder="Informe o telefone" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group id="input-group-55" label="E-mail" label-for="input-55">
                <b-form-input id="input-55" v-model="produtor.email"
                  type="text" placeholder="Informe o e-mail"></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group id="input-group-9" label="Estado" label-for>
                <v-select :key="key" v-model="produtor.id_estado" class="style-select" label="nome" :options="estados"
                  :reduce="(estado) => estado.id_estado" :dense="true"></v-select>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group id="input-group-9" label="Cidade" label-for="">
                <!-- <select :key="key" v-model="produtor.id_municipio" class="form-control" aria-placeholder="">
                  <option v-for="cidade of cidades" :key="cidade.id_municipio" :value="cidade.id_municipio">{{ cidade.nome
                  }}
                  </option>
                </select> -->
                <v-select v-model="produtor.id_municipio" class="style-select" label="nome" :options="cidades"
                  :reduce="(cidade) => cidade.id_municipio" :dense="true"></v-select>

                <!-- <v-select :key="key" v-model="produtor.id_municipio" class="style-select" label="nome" :options="cidades"
                  :reduce="(cidade) => estado.id_estado" :dense="true"></v-select> -->

              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group id="input-group-5" label="Latitude" label-for="input-5">
                <b-form-input id="input-5" v-model="produtor.latitude" type="text" placeholder="Informe a latitude"
                  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group id="input-group-5" label="Longitude" label-for="input-5">
                <b-form-input id="input-5" v-model="produtor.longitude" type="text" placeholder="Informe a longitude"
                  required></b-form-input>
              </b-form-group>
            </div>
          </div>
        </b-tab>
        <b-tab title="Local de Aplicação/Entrega de Embalagens">
          <div class="row">
            <div class="col-md-4">
              <b-form-group id="input-group-9" label="Local de aplicação" label-for="input-9">
                <template v-slot:label>
                  Local de aplicação
                  <b-icon v-b-tooltip.hover role="button"
                    title="Caso o endereço da aplicação do defensivo for diferente do endereço da Propriedade, favor informar o endereço do local onde vai ser feito a aplicação."
                    icon="exclamation-circle-fill" variant="info"></b-icon>
                </template>
                <b-form-input id="input-9" v-model="produtor.local_aplicacao" type="text"
                  placeholder="Informe o local de aplicação" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-12"></div>
            <div class="col-md-4">
              <b-form-group id="input-group-10" label="Local de recebimento das embalagens" label-for="input-10">
                <template v-slot:label>
                  Local de recebimento das embalagens
                  <b-icon v-b-tooltip.hover role="button"
                    title="Informar o endereço completo do local de entrada das embalagens vazias"
                    icon="exclamation-circle-fill" variant="info"></b-icon>
                </template>
                <b-form-input id="input-10" v-model="produtor.unid_recebimento" type="text"
                  placeholder="Informe a unidade de recebimento da embalagem" required></b-form-input>
              </b-form-group>
            </div>
          </div>
        </b-tab>
      </b-tabs>

      <b-button type="submit" variant="primary" @click.prevent="salvarProdutor">Salvar</b-button>
    </b-form>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </div>
</template>
<script>
import produtorRural from '@src/services/produtor-rural'
import estado from '@/src/services/estado'
import { mask } from 'vue-the-mask'
import Loading from 'vue-loading-overlay'
import CEPService from "@/src/services/cep";

export default {
  components: {
    Loading,
  },
  directives: { mask },
  props: {
    produtor: {},
  },
  data() {
    return {
      produtorEstado: '',
      produtorCidade: '',
      estados: [],
      cidades: [{
        nome: 'Selecione',
        id_municipio: 0
      }],
      estadoSelecionado: {},
      cidadeSelecionada: {},
      modal: {
        show: false,
        mensagems: null,
        sucesso: null,
      },
      isLoading: false,
      localAplicacao: '',
      key: 0,
    }
  },
  watch: {
    'produtor.id_estado'() {
      this.listandoCidade(this.produtor.id_estado)
    },
    'produtor.id_municipio'() {
      this.produtor.id_municipio = this.produtor.id_municipio
    },
    produtor(newValue) {
      if (newValue && newValue.endereco) {
        this.localAplicacao = newValue.endereco;
      }
    },
  },
  created() { },
  mounted() {
    if (this.produtor && this.produtor.endereco) {
      this.localAplicacao = this.produtor.endereco;
    }
    this.listaEstado()
    if (this.produtor.id_estado)
      this.listandoCidade(this.produtor.id_estado)
  },
  methods: {
    findAddress(cep) {
      CEPService.find(cep)
        .then(response => {
          if (response.erro) {
            this.$bvToast.toast('CEP não encontrado. Por favor, verifique e tente novamente.', {
              variant: 'danger',
              solid: true,
              noCloseButton: false,
              toaster: 'b-toaster-top-center',
            });
            return;
          }

          this.produtor.endereco = response.logradouro;
          this.produtor.localidade = response.bairro;
          this.produtor.complemento = response.complemento;

          let state = this.estados.find(i => i.nome === response.state);
          this.produtor.id_estado = state ? state.id_estado : "";
          this.key++;
          this.listandoCidadesESelecionar(this.produtor.id_estado, response);
        })
        .catch(error => {
          let mensagemErro = 'Erro ao buscar o endereço. Por favor, tente novamente.';
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message.join(', ');
          }

          this.$bvToast.toast(mensagemErro, {
            variant: 'danger',
            solid: true,
            noCloseButton: false,
            toaster: 'b-toaster-top-center',
          });
        });
    },
    procurarCEP() {
      const cep = this.produtor.cep;
      if (cep && cep.length >= 5) {
        this.findAddress(cep);
      }
    },
    estadoId() {
      const token = this.$store.state.auth.currentUser.token
      estado.idEstado(token, this.produtor.id_estado).then((resposta) => {
        console.log(this.produtor.id_estado, resposta.data)
        this.produtorEstado = resposta.data.nome
        this.estadoSelecionado = this.produtorEstado
      })
    },
    loading(a) {
      a = !this.isLoading
      return a
    },
    modalShow() {
      if (this.modal.show === true) {
        this.modal.show = false
      }
    },
    listandoCidadesESelecionar(id, response) {
      const token = this.$store.state.auth.currentUser.token;
      this.isLoading = this.loading(this.isLoading);

      estado.listaCidades(token, id).then((resposta) => {
        this.cidades = resposta.data.cidades;

        let city = this.cidades.find(i => i.nome === response.localidade);
        this.produtor.id_municipio = city ? city.id_municipio : "";

        this.key++;
        this.isLoading = this.loading(this.isLoading);
      });
    },
    listandoCidade(id) {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      estado.listaCidades(token, id).then((resposta) => {
        if (this.produtor.id_estado) {
          this.cidades = resposta.data.cidades.sort((a, b) => {
            if (a.nome < b.nome) return -1;
            if (a.nome > b.nome) return 1;
            return 0;
          });
        }

        this.key++
        this.isLoading = this.loading(this.isLoading)
      })
    },
    listaEstado() {
      const token = this.$store.state.auth.currentUser.token
      estado.lista(token).then((resposta) => {
        this.estados = resposta.data.estados
      })
    },
    selecionaMunicipio() {
      if (this.produtor.id_municipio != undefined) {
        const token = this.$store.state.auth.currentUser.token
        estado.municipio(token, this.produtor.id_municipio).then((resposta) => {
          this.produtorCidade = resposta.data.nome
          this.listandoCidade(this.produtor.id_estado)
          this.cidadeSelecionada = this.produtorCidade
        })
      } else {
        this.listandoCidade(this.produtor.id_estado)
      }
    },
    salvarProdutor() {
      const token = this.$store.state.auth.currentUser.token
      if (this.produtor.id_produtor_rural) {
        this.isLoading = this.loading(this.isLoading)
        produtorRural
          .update(token, this.produtor)
          .then((resposta) => {
            this.$emit('saved', {
              response: resposta,
              produtor: { ...this.produtor },
            })
            this.modal.show = true
            this.$bvToast.toast('Atualizado com sucesso', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.modal.mensagems = resposta.data.aviso
            this.isLoading = this.loading(this.isLoading)
          })
          .catch((erro) => {
            this.$bvToast.toast(erro.response.data.message.join(', '), {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = this.loading(false)
          })
      } else {
        this.isLoading = this.loading(this.isLoading)
        produtorRural
          .salvar(token, this.produtor)
          .then((resposta) => {
            this.isLoading = this.loading(this.isLoading)
            if (!resposta.data.sucesso) {
              this.$bvToast.toast(resposta.data.aviso.mensagem, {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            } else {
              this.$emit('saved', {
                response: resposta,
                produtor: { ...this.produtor },
              })
              this.$bvToast.toast('Salvo com sucesso!', {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })

              this.produtor = {}
            }
          })
          .catch((erro) => {
            this.isLoading = this.loading(this.isLoading)
            this.$bvToast.toast(erro.response.data.mensagem, {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          })
      }
    },
  },
}
</script>

<style></style>
